import React, { useState, useEffect } from 'react';
import { Table, Dimmer, Segment, Loader, Dropdown } from 'semantic-ui-react';
import IconButton from '../../../../components/IconButton';
import { ClickableTableCell, SelectableTableRow } from '../../../../styles';
import { maskCpfOrCnpj } from '../../../../services/masks';
import { Header, NotFoundWrapper, TableComponent, TableWrapper } from './styles';
import { FeatureEnum } from '../../../../enums/authz-feature.enum';
import { ActionEnum } from '../../../../enums/authz-action.enum';
import { Blacklist } from '../../../../types/Blacklist';
import { statusOptions } from '../../types';
import AuthorizationContainer from '../../../../components/AuthorizationContainer';
import { DateToStringDateTime } from '../../../../services/date';
import TablePaginationMenu from '../../../../components/TablePaginationMenu';

type Props = {
  blacklist: Blacklist[];
  isLoading: boolean;
  getData: Function;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  dataCount: number;
  handleSelectItem: (item: Blacklist) => void;
  handleEditItem: (itemId: string) => void;
  isBackofficeTest: boolean;
};

const BlacklistTable = (props: Props): JSX.Element => {
  const {
    blacklist,
    isLoading,
    currentPage,
    setCurrentPage,
    dataCount,
    handleSelectItem,
    handleEditItem,
    isBackofficeTest
  } = props;

  const [listData, setListData] = useState<Blacklist[]>([]);

  useEffect(() => {
    setListData(blacklist);
  }, [blacklist]);

  function renderTableData(blacklist: Array<Blacklist>): Array<JSX.Element> {
    const trigger = (
      <AuthorizationContainer action={ActionEnum.read} feature={FeatureEnum.preregisters}>
        <IconButton name="ellipsis vertical" disabled={isBackofficeTest} />
      </AuthorizationContainer>
    );
    return blacklist.map((item: Blacklist) => {
      return (
        <SelectableTableRow key={item?.id}>
          <Table.Cell>
            {DateToStringDateTime(item?.createdAt || new Date(0, 0, 0))}
          </Table.Cell>

          <ClickableTableCell onClick={() => handleSelectItem(item)}>
            {item?.name}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(item)}>
            {maskCpfOrCnpj(item?.document)}
          </ClickableTableCell>

          <ClickableTableCell onClick={() => handleSelectItem(item)}>
            {statusOptions.find(status => status.value === item?.status)?.text}
          </ClickableTableCell>

          <ClickableTableCell width={1} textAlign={'right'}>
            <AuthorizationContainer
              action={ActionEnum.update}
              feature={FeatureEnum.blacklist}
            >
              <Dropdown
                trigger={trigger}
                icon={null}
                direction="left"
                disabled={isBackofficeTest}
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    icon="pencil"
                    text={'Editar Item'}
                    onClick={() => {
                      if (item?.id) handleEditItem(item.id);
                    }}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </AuthorizationContainer>
          </ClickableTableCell>
        </SelectableTableRow>
      );
    });
  }

  return (
    <TableComponent>
      <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
        {listData && listData.length > 0 ? (
          <TableWrapper>
            <Table>
              <Header>
                <Table.Row>
                  <Table.HeaderCell>CRIADO EM</Table.HeaderCell>
                  <Table.HeaderCell>NOME</Table.HeaderCell>
                  <Table.HeaderCell>DOCUMENTO</Table.HeaderCell>
                  <Table.HeaderCell>STATUS</Table.HeaderCell>
                  <Table.HeaderCell width={1} textAlign={'right'}>
                    <IconButton name="setting" />
                  </Table.HeaderCell>
                </Table.Row>
              </Header>
              <Table.Body>{renderTableData(blacklist)}</Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="17">
                    <TablePaginationMenu
                      currentPage={currentPage}
                      dataCount={dataCount}
                      setCurrentPage={setCurrentPage}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </TableWrapper>
        ) : (
          <NotFoundWrapper>
            <p>Blacklist não encontrada</p>
          </NotFoundWrapper>
        )}
      </Dimmer.Dimmable>
    </TableComponent>
  );
};

export default BlacklistTable;
